import { lazyRegisterAddDiagnosticCallback } from 'owa-diagnostic-report';

export function registerDiagnosticCallback(
    diagnosticCallback: () => { key: string; value: string }
): void {
    lazyRegisterAddDiagnosticCallback
        .import()
        .then(registerAddDiagnosticCallback => registerAddDiagnosticCallback(diagnosticCallback));
}
